import { useRoutes } from "react-router-dom";
import Dashboard from "../../modules/Fixiter/pages/Dashboard";
import Layout from "../../components/Layout";
import Courses from "../../modules/Fixiter/pages/Courses";
import Certificate from "../../modules/Fixiter/pages/Certificate";
import { useOnboard } from "../../hooks/OnboardContext";
import LayoutIframe from "../../components/LayoutIframe";
import Logon from "../../modules/Logon";
import UsersProfile from "../../components/UsersProfile";
import PlanExpired from "../../modules/Fixiter/pages/PlanExpired";
import BracingTypes from "../../modules/Fixiter/pages/BracingTypes";
import Solutions from "../../modules/Orders/Solutions";
import { CreateOrder } from "../../modules/Orders/CreateOrder";
import { Onboard } from "../../modules/Fixiter/pages/Onboard";

function FixiterRoutes() {
  const { planHasExpired } = useOnboard();

  const expiredRoutes = useRoutes([
    { path: "/", element: <Logon /> },
    {
      path: "/fixiter/dashboard",
      element: (
        <LayoutIframe>
          <PlanExpired />
        </LayoutIframe>
      ),
    },
  ]);

  const fixiterRoutes = useRoutes([
    {
      path: "/fixiter/dashboard",
      element: (
        <Layout>
          <Dashboard />
        </Layout>
      ),
    },
    {
      path: "/fixiter/courses",
      element: (
        <Layout>
          <Courses />
        </Layout>
      ),
    },
    {
      path: "/fixiter/certificate",
      element: (
        <Layout>
          <Certificate />
        </Layout>
      ),
    },
    {
      path: "/fixiter/profile/:options",
      element: (
        <Layout>
          <UsersProfile />
        </Layout>
      ),
    },
    {
      path: "/fixiter/categories/:field_key",
      element: (
        <Layout>
          <BracingTypes />
        </Layout>
      ),
    },
    {
      path: "/fixiter/solutions/:category_key",
      element: (
        <Layout>
          <Solutions />
        </Layout>
      ),
    },
    {
      path: "/fixiter/order/:solution_key/:solution_type",
      element: (
        <Layout>
          <CreateOrder />
        </Layout>
      ),
    },
    {
      path: "/fixiter/order/:solution_key/:solution_type/:size",
      element: (
        <Layout>
          <CreateOrder />
        </Layout>
      ),
    },
    {
      path: "/fixiter/onboard",
      element: (
        <Layout>
          <Onboard />
        </Layout>
      ),
    }
  ]);

  if (planHasExpired) {
    return expiredRoutes;
  }

  return fixiterRoutes;
}

export default FixiterRoutes;
